// extracted by mini-css-extract-plugin
export default {"card":"ACard_card__R5VE5"};